module.exports = __webpack_public_path__ + "static/media/_MG_5368.1d7d2d35.jpg";